import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";
import { GameSmall } from './../Game/GameSmall.jsx'
import RiveComponent from "../Shared/RiveComponent";

export class MojCasinoHorizontal extends React.Component {

    constructor(props) {
        super(props);

        this.renderIgra = this.renderIgra.bind(this);
        this.dohvatiNajcesceIgre = this.dohvatiNajcesceIgre.bind(this);
        this.renderDone = this.renderDone.bind(this);
        this.container = React.createRef();
        this.pages = React.createRef();
        this.filterGamesByCategory = this.filterGamesByCategory.bind(this);
    }

    renderIgra(igra, igra2, i) {
        let step = this.props.showSmall || this.props.brojRedova == 1 ? 1 : 2;
        return <div key={igra.s} className={"margin-bottom-small game-item game-item2" + (!this.props.showSmall ? "" : " game-item3") + " gameid-" + igra.id} data-index={i / step} >

            {igra && igra.length != 0 &&
                <GameSmall
                    showRtp={this.props.showRtp}
                    routePrefix={this.props.routePrefix}
                    categories={this.props.categories}
                    showJackpotValue={this.props.showJackpotValue}
                    showGameName={this.props.showGameName}
                    from={this.props.from} igra={igra}
                    showJackpot={true}
                    extraClass={""}
                    goLazyImage={true}
                    iconImage={(this.props.isAppIcon ? true : this.props.showSmall)}
                    brands={this.props.brands}
                    isVerticalImage={this.props.isVerticalImage}
                    // GamePosition podaci, HizmanB
                    PageName={this.props.PageName}
                    GamePosition={(i / step) + 1}
                    PositionType={this.props.PositionType}
                    ComponentName={this.props.ComponentName}
                    ComponentPosition={this.props.ComponentPosition}
                    IsIcon={this.props.IsIcon}
                    SliderName={this.props.SliderName}
                    SliderPosition={this.props.SliderPosition}
                   
            />
            }

            {igra2 && igra2.length != 0 &&
                <GameSmall
                showRtp={this.props.showRtp}
                routePrefix={this.props.routePrefix}
                categories={this.props.categories}
                showJackpotValue={this.props.showJackpotValue}
                showGameName={this.props.showGameName}
                from={this.props.from}
                igra={igra2}
                showJackpot={true}
                extraClass={""}
                goLazyImage={true}
                iconImage={(this.props.isAppIcon ? true : this.props.showSmall)}
                brands={this.props.brands}
                isVerticalImage={this.props.isVerticalImage}
                // GamePosition podaci, HizmanB
                PageName={this.props.PageName}
                GamePosition={(i / step) + 1}
                PositionType={this.props.PositionType}
                ComponentName={this.props.ComponentName}
                ComponentPosition={this.props.ComponentPosition}
                IsIcon={this.props.IsIcon}
                SliderName={this.props.SliderName}
                SliderPosition={this.props.SliderPosition}
            />
            }

            {/* fix, ako je neparno igrici i dva reda onda glumim parni broj */}
            {!igra2 && step > 1 && <a className="game-item-small empty relative"><div className="relative"><div className="relative"><div><div className="game-img"></div></div></div></div><div className="relative"><span className="game-name ">&nbsp;</span></div></a>}
        </div>
    }

    sortJackpotGames(games, limit) {
        const jackpotGames = [];
        const providerBrands = this.props.brands;
        const catId = this.props.catId;

        if (!games || !games.length) return [];

        // Grupiranje igara po brendu (koji ima jackpot u aktivnoj kategoriji)
        const brandGamesMap = {};
        Object.keys(providerBrands).forEach(brandID => {
            const filtered = games.filter(x =>
                !!x.kt && Object.keys(x.kt).includes(catId) &&
                x.bID == parseInt(brandID)
            );
            if (filtered.length) {
                brandGamesMap[brandID] = filtered;
            }
        });

        // Top igre po brendu
        const amusnetGames = (brandGamesMap[105] || []).sort((a, b) => b.jp - a.jp);
        const playNGoGames = (brandGamesMap[101] || []).sort((a, b) => b.jp - a.jp);
        const synotGames = (brandGamesMap[112] || []).sort((a, b) => b.jp - a.jp);

        // Ostali provideri: max jedna igra po brendu, sortirano po jackpotu
        const otherGamesUnique = Object.entries(brandGamesMap)
            .filter(([bID]) => ![105, 101, 112].includes(parseInt(bID)))
            .map(([bID, list]) => list.sort((a, b) => b.jp - a.jp)[0])
            .filter(Boolean)
            .sort((a, b) => b.jp - a.jp);

        const result = [];

        // Dodavanje igara na fiksne pozicije
        if (amusnetGames[0]) result[0] = amusnetGames[0];
        if (playNGoGames[0]) result[1] = playNGoGames[0];
        if (amusnetGames[1]) result[2] = amusnetGames[1];
        if (synotGames[0]) result[3] = synotGames[0];
        if (amusnetGames[2]) result[4] = amusnetGames[2];

        // Popuni ostale pozicije s ostalim brandovima (sortirano po jackpotu, jedan po provideru)
        let i = 0;
        for (let game of otherGamesUnique) {
            while (i < limit && result[i]) i++;
            if (i < limit) result[i] = game;
            else break;
        }

        // Ako i dalje nema dovoljno igara, dodaj random igre iz drugih providera
        const usedIDs = new Set(result.map(g => g?.id).filter(Boolean));
        const fallbackGames = games.filter(g =>
            g.kt && Object.keys(g.kt).includes(catId) &&
            ![105, 101, 112].includes(g.bID) &&
            !usedIDs.has(g.id)
        );

        // Shuffle fallback igre
        for (let i = fallbackGames.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [fallbackGames[i], fallbackGames[j]] = [fallbackGames[j], fallbackGames[i]];
        }

        for (let g of fallbackGames) {
            if (result.length >= limit) break;
            result.push(g);
        }

        return result.slice(0, limit);
    }

    filterGamesByCategory() {
        var igraPozicijaArray = [];
        var games;
        var self = this;
        if (this.props.igraPozicija) {
            //Napunimo predefinirane igre na pozicije
            this.props.igraPozicija.forEach(game => {
                let igra = self.props.igre.find(x => x.s == game.sifraMobile);
                if (igra) igraPozicijaArray[game.pozicija] = igra;
            });
        }

        games = this.props.igre.filter(x => Object.keys(x.kt).indexOf(this.props.catId) != -1)
            .sort((igra1, igra2) => {
                var val1 = igra1.kt && igra1.kt[this.props.catId] ? igra1.kt[this.props.catId] : 0;
                var val2 = igra2.kt && igra2.kt[this.props.catId] ? igra2.kt[this.props.catId] : 0;
                return val1 - val2;
            });

        if (this.props.catId == "59") { //Jackpot Cards, amusnet sort igrica koje hoceju da budu prve
            let gamesToFind = ["EGT-Shining_Crown", "EGT-40_Golden_Coins", "EGT-100_Super_Hot", "EGT-Candy_Palace", "EGT-20_Power_Hot", "EGT-Extra_Crown", "EGT-Kemets_Treasures", "EGT-Diamond_Plus"]

            let amusnetGames = gamesToFind.map(x => games.find(it => it.s === x)).filter(it => it !== undefined);
            let gamesWithoutAmusnetGames = games.filter(obj => !gamesToFind.includes(obj.s));
            return [...amusnetGames, ...gamesWithoutAmusnetGames];
        }

        if (this.props.randomSort) {
            var rnds = casino.utils.generateTodayRandomNumber(games.length + 50).slice(this.props.randomSortOffset || 0);
            games = games.map((x, i) => { x.rnd = rnds[i]; return x; }).sort((x, y) => x.rnd < y.rnd ? -1 : 1);
        }


        if (this.props.igraPozicija)
            games = this.postaviIgraPozicija(igraPozicijaArray, games);

        return games;
    }

    postaviIgraPozicija(igraPozicijaArray, games) {
        let i = 0;
        do {
            if (igraPozicijaArray[i] != undefined) {
                //igra je postavljena, preskačemo polje
                i = i + 1;
            }
            else if (igraPozicijaArray[i] === undefined && !igraPozicijaArray.find(x => x != null && x.id == games[0].id)) {
                //igra nije postavljena i ne postoji u listi koju kreiramo 
                igraPozicijaArray[i] = games.shift();

                i = i + 1;
            } else {
                //Igra je već postoji u listi koju kreiramo
                games.shift();
            }
        } while (games.length > 0);

        return igraPozicijaArray;
    }

    dohvatiNajcesceIgre() {
        var games = [];
        if (this.props.superBotGames) {
            this.props.superBotGames.map(x => {
                var igra = this.props.igre.find(y => y.s == x.sifraMobile);
                if (igra) {
                    games.push(igra);
                }

            });
        }
        else if (this.props.games) {
            this.props.games.map(x => {
                var igra = this.props.igre.filter(y => y.s == (typeof x === 'string' ? x : x.s))[0];
                if (igra) {
                    igra.rtp = x.rtp;
                    games.push(igra);
                }

            });

        }
        else if (this.props.catId && this.props.jackpotSort) {
            games = this.sortJackpotGames(this.props.igre, 21);
        } else if (this.props.catId) {
            games = this.filterGamesByCategory();
            // games = this.props.igre.filter(x => Object.keys(x.kt).indexOf(this.props.catId) != -1)
            //     .sort((x, y) => x.kt[this.props.catId] < y.kt[this.props.catId] ? -1 : 1);
        } else if (this.props.tema) {
            var temaId = casino.utils.getKeyByValue(this.props.tags, this.props.tema.tag)?.toString();

            games = this.props.igre.filter(x => x.t && Object.keys(x.t).indexOf(temaId) != -1)
                .sort((x, y) => x.t[temaId] < y.t[temaId] ? -1 : 1);
        } else if (this.props.brand) {
            let brand = this.props.brand;

            //nove
            let newGames = this.props.igre.filter(x => x.brand == brand && x.p && Object.keys(x.p).indexOf("n") != -1);
            if (newGames.length < 21) {
                let oldGames = this.props.igre.filter(x => x.brand == brand && !(x.p && Object.keys(x.p).indexOf("n") != -1)).sort((x, y) => x.so[0] < y.so[0] ? -1 : 1).slice(0, 21 - newGames.length);
                games = newGames.concat(oldGames)
            } else {
                games = newGames;
            }
        }

        if (!this.props.igraPozicija && this.props.randomSort && this.props.catId !== "59") { // Jackpot cards kategorija amusenet hoce specificne igrice da budu prve pa micem random za njih
            var rnds = casino.utils.generateTodayRandomNumber(games.length + 50).slice(this.props.randomSortOffset || 0);
            games = games.map((x, i) => { x.rnd = rnds[i]; return x; }).sort((x, y) => x.rnd < y.rnd ? -1 : 1)
        }

        var gui = [];
        let step = this.props.showSmall || this.props.brojRedova == 1 ? 1 : 2;
        for (var i = 0; i < games.length; i = i + step) {
            if (i < (20 * step)) {
                if (games[i]) {
                    gui.push(this.renderIgra(games[i], !this.props.showSmall && !(this.props.brojRedova == 1) && games[i + 1], i));
                }
            }
        }
        return gui;
    }


    componentWillUnmount() {
        if (this.pagesObserver)
            this.pagesObserver.disconnect();
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.props.tema != nextProps.tema && this.props.brand != nextProps.brand && !this.props.brands)
            this._imagesLoaded = false;

        return !this._imagesLoaded;
    }

    renderDone() {
        if (this.props.igre && !this._imagesLoaded) {
            casino.utils.lazyImages.mountEventLazyLoadImages();
            this._imagesLoaded = true;

            let images = [].slice.call(this.container.current.querySelectorAll("div.game-item2"));
            //let pages = [].slice.call(this.pages.current.querySelectorAll("span"));

            this.pagesObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {

                    let lazyImage = entry.target;
                    var index = +lazyImage.dataset.index;

                    // if (entry.isIntersecting) {
                    //     pages[index].classList.add("active")
                    // }
                    // else {
                    //     pages[index].classList.remove("active")
                    // }
                });
            });

            images.map(x => this.pagesObserver.observe(x));

            var urlInfo = casino.utils.parseQuery(this.props.route.location.search);

            if (urlInfo.lastfrom) {
                var lastFrom = urlInfo.lastfrom;
                let div = urlInfo.lastfrom.split('-').length == 3 ? urlInfo.lastfrom.split('-')[0] + '-' + urlInfo.lastfrom.split('-')[1] : urlInfo.lastfrom;

                if (lastFrom == this.props.from && urlInfo.lastgame) {
                    setTimeout(() => {
                        var games = document.getElementById(lastFrom).getElementsByClassName("gameid-" + urlInfo.lastgame);
                        if (games.length > 0) {
                            var offset = games[0].offsetLeft;
                            document.getElementById(lastFrom).getElementsByClassName("horizontal-items--container")[0].scrollLeft = offset - 50;
                        }
                    }, 200);
                }
            }
        }
    }

    componentDidMount() {

        this.renderDone();
    }

    componentDidUpdate(prevProps, prevState) {
        this.renderDone();
    }
    

    render() {
        let najcesceIgre = this.props.igre && this.dohvatiNajcesceIgre();
        return <div className={"moj-casino-line " + this.props.sifra} id={this.props.from} >
            {this.props.sifra == "mjesec-zaljubljenih" &&
                <div className="rive-hearts">
                    <RiveComponent
                        lazyLoad={true}
                        cacheBust={`c=${casino.config.guiCacheVerzija}`} 
                        src="Content/Rive/Rive_Mjesec_zaljubljenih_animation.riv"
                        useOffscreenRenderer={true}
                        playRequest={true}
                        disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }}
                    />
                </div>}
            <h2 className={"homepage-margin2 " + (this.props.showAll ? '' : 'no-padding')}>
                {!this.props.showAll && <span>{this.props.name}</span>}
                {this.props.showAll && <a className="component-title" href={"?lastTab=" + this.props.catId} >{this.props.name}</a>}
                {!this.props.showAll && this.props.jackpotSort && <a className="btn-red" href={"?lastTab=" + this.props.catId} >Prikaži sve</a>}
                {/*{this.props.showAll && !this.props.brandID && < a className="btn-red" href={"?lastTab=" + this.props.catId} >Prikaži sve</a>}*/}
                {/*{this.props && this.props.brandID != null && this.props.brandID != undefined && < a className="btn-red" href={"provideri/" + this.props.brands[this.props.brandID].nameNormalizirano} >Prikaži sve2</a>}*/}
            </h2>
            {this.props.desc && <div className="desc homepage-margin2">{this.props.desc}</div>}

            <div className='horizontal-items v3'>
                <div className='horizontal-items--container clearfix mojcasino-padding v3' ref={this.container}>
                    {najcesceIgre}
                </div>
                <div className='horizontal-items--navigation no-buttons'>  {/* sluzi za skrivanje scroolbarsa */}
                </div>
                {/* <div className="small-page">
                    <div className="line"></div>
                    <div className="pages" ref={this.pages}>
                        {najcesceIgre && najcesceIgre.map((x, i) => <span key={i} />)}
                    </div>
                    <div className="line"></div>
                </div> */}
            </div>
        </div>
    }
};
